import React, { useState, useEffect } from 'react';
import { fetchProductDetails } from '../../../../../utils/api-service/get-services';
import ColorSpecification from './ColorSpecification';
import { useParams } from 'react-router-dom';

const ProductSpecifications = ({ productId, selectedCategory }) => {
    const { id } = useParams();
    const effectiveProductId = productId || id;
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);
    const [activeColorway, setActiveColorway] = useState(null);
    const [productType, setProductType] = useState("");

    useEffect(() => {
        if (effectiveProductId) {
            loadProduct();
        }
    }, [effectiveProductId]);

    useEffect(() => {
        if (selectedCategory) {
            setProductType(selectedCategory?.productType);
        }
    }, [selectedCategory]);
    const loadProduct = async () => {
        setLoading(true);
        try {
            const response = await fetchProductDetails(effectiveProductId);
            if (response) {
                setProduct(response);
                if (response?.colorways && response?.colorways.length > 0) {
                    setActiveColorway(response?.colorways[0]._id);
                }
            }
        } catch (error) {
            console.error('Error loading product:', error);
        } finally {
            setLoading(false);
        }
    };

    if (!effectiveProductId) {
        return (
            <div className="card">
                <div className="card-body text-center py-5">
                    <i className="bi bi-info-circle fs-1 text-muted"></i>
                    <h5 className="mt-3">No Product Selected</h5>
                    <p className="text-muted">Please save product basic details first.</p>
                </div>
            </div>
        );
    }

    if (loading) {
        return <div className="text-center py-5">Loading...</div>;
    }

    if (!product || !product.colorways || product.colorways.length === 0) {
        return (
            <div className="card">
                <div className="card-body text-center py-5">
                    <i className="bi bi-palette fs-1 text-muted"></i>
                    <h5 className="mt-3">No Colorways Added</h5>
                    <p className="text-muted">Please add colorways in Product Details first.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="product-specifications">
            {/* Colorway Tabs */}
            <ul className="nav nav-tabs mb-4">
                {product.colorways.map((cw, index) => (
                    <li className="nav-item" key={cw._id}>
                        <button
                            className={`nav-link ${activeColorway === cw._id ? 'active' : ''}`}
                            onClick={() => setActiveColorway(cw._id)}
                        >
                            {cw.color?.name || cw.color?.code || `Colorway ${index + 1}`}
                        </button>
                    </li>
                ))}
            </ul>

            {/* Active Colorway Specifications */}
            {activeColorway && (
                <ColorSpecification
                    productId={effectiveProductId}
                    productType={productType}
                    colorwayId={activeColorway}
                    colorwayName={product.colorways.find(cw => cw._id === activeColorway)?.color?.name || 'Colorway'}
                />
            )}
        </div>
    );
};

export default ProductSpecifications;